<div class="quantity-control-group" [class.quantity-control-group--start]="align === 'start'">
  <ng-content></ng-content>
  @if (soldOutLabel && value === 0) {
    <span class="quantity-control-sold-out" data-test="sold-out">{{ soldOutLabel }}</span>
  } @else if (addLabel && value === 0) {
    <button
      type="button"
      class="btn btn-outline quantity-control-add"
      [attr.data-test]="addTestId"
      [disabled]="disabled"
      (click)="handleIncreaseClick()"
    >
      <plys-button-label [loading]="displayLoading || buttonRecentlyClicked">{{ addLabel }}</plys-button-label>
    </button>
  } @else {
    @if ((min > 0 && value >= min) || min === 0) {
      <button
        (click)="handleDecreaseClick()"
        [disabled]="decreaseDisabled"
        class="btn btn-outline btn-circle"
        [ngClass]="{
          'btn-circle-sm': size === 'sm',
        }"
      >
        -
      </button>
      <span class="quantity-control-value">{{ value }}</span>
    }

    @if (max !== null && max === value) {
      <span class="btn btn-circle btn-circle-sm btn-primary btn-checked"> </span>
    }

    @if (max === null || max !== value) {
      <button
        (click)="handleIncreaseClick()"
        [disabled]="disabled || !!soldOutLabel"
        class="btn btn-tertiary btn-circle"
        [ngClass]="{
          'btn-circle-sm': size === 'sm',
        }"
      >
        <plys-button-label [loading]="displayLoading || buttonRecentlyClicked"> + </plys-button-label>
      </button>
    }
  }
  <!-- A short state next to the counter, after +; see the tickets page's "Vol" (PAUL-3900). -->
  <ng-content select="[plysQuantityNote]"></ng-content>
</div>
